const ComoPagar = () => {
  return (
    <p>
      <strong>Mercadopago</strong> Transferencia / <strong>Depósito</strong>
      Una vez elegido, obtendrás los datos de la cuenta y el monto a pagar.
      <strong>Showroom</strong>: pago en efectivo.
    </p>
  );
};

export default ComoPagar;
